import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { useCasesGeneralFilters } from './hook';
import { CasesGeneralFiltersProps } from './props';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import { formatParams } from '../../../../../shared/utils/params';

export const CasesGeneralFilters = ({
    onFilter,
    loading,
}: CasesGeneralFiltersProps) => {
    const { formik, typification1, typification2 } =
        useCasesGeneralFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    touched={formik.touched.callId}
                    errors={formik.errors.callId}
                    value={formik.values.callId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Identificación"
                    name="document"
                    size="small"
                    touched={formik.touched.document}
                    errors={formik.errors.document}
                    value={formik.values.document}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Sucursal"
                    name="branch"
                    size="small"
                    touched={formik.touched.branch}
                    errors={formik.errors.branch}
                    value={formik.values.branch}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Poliza"
                    name="policie"
                    size="small"
                    touched={formik.touched.policie}
                    errors={formik.errors.policie}
                    value={formik.values.policie}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams([])}
                    label="Estado"
                    name="status"
                    size="small"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={typification1}
                    label="Tipificación 1"
                    name="typification1"
                    size="small"
                    touched={formik.touched.typification1}
                    errors={formik.errors.typification1}
                    value={formik.values.typification1 as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typification1', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={typification2}
                    label="Tipificación 2"
                    name="typification2"
                    size="small"
                    touched={formik.touched.typification2}
                    errors={formik.errors.typification2}
                    value={formik.values.typification2 as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typification2', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación inicial"
                    name="startCreatedAt"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    value={
                        formik.values.startCreatedAt
                            ? dayjs(formik.values.startCreatedAt)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'startCreatedAt',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación final"
                    name="endCreatedAt"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    value={
                        formik.values.endCreatedAt
                            ? dayjs(formik.values.endCreatedAt)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'endCreatedAt',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Placa"
                    name="plate"
                    size="small"
                    touched={formik.touched.plate}
                    errors={formik.errors.plate}
                    value={formik.values.plate}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Radicado de correspondencia"
                    name="correspondenceFiling"
                    size="small"
                    touched={formik.touched.correspondenceFiling}
                    errors={formik.errors.correspondenceFiling}
                    value={formik.values.correspondenceFiling as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
